const state = {
  tip: '',
  nodeName: '',
  nodeNo: '',
  province: '',
  invType: '',
  appointDate: '',
  custName: '',
  identifyId: '',
  mobile: '',
  appointType: '1A'
}

const mutations = {
  SET_TIP(state, tip) {
    state.tip = tip
  },
  SET_NODE(state, { nodeNo, nodeName }) {
    state.nodeNo = nodeNo
    state.nodeName = nodeName
  },
  SET_DATA(state, { province, invType, appointDate, custName, identifyId, mobile, appointType }) {
    state.province = province
    state.invType = invType
    state.appointDate = appointDate
    state.custName = custName
    state.identifyId = identifyId
    state.mobile = mobile
    state.appointType = appointType
  },
  RESET_ORDER(state) {
    state.tip = ''
    state.nodeName = ''
    state.nodeNo = ''
    state.province = ''
    state.invType = ''
    state.appointDate = ''
    state.custName = ''
    state.identifyId = ''
    state.mobile = ''
    state.appointType = '1A'
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
